import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';

import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Input from './Input';
import InputDate from './InputDate';
import consts from '../libs/consts';

import Radios from './Radios';
import Checkbox from './Checkbox';
import Profiles from './Profiles';
import { close, loadingflas, open, listupdater } from '../redux/popupSlice';
import Select from './Select';
import DaumPostcode from 'react-daum-postcode';
import { getBase64, getBase64toDataUrl, getMemberinfo, numFormat, heckName } from '../utils/utils';
import InfoViewlists from './InfoViewlists';
import * as APIS from "../utils/service";
import DatePicker from "react-datepicker";

export default function ContractwriterPage3Viewer(props) {

    const {
        row={},
        setviewpages=()=>{},
        scrolTopFunc=()=>{},
        contractWirteSubmit=()=>{}
    } = props;
    
    const { configdata } = useSelector(s => s.configReducer);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [sell_type, setsell_type] = useState('매매');   
    const [category, setcategory] = useState('집합건물');
    let yearDatas = [];
    let monthDatas = [];
    let dayDatas = [];
    //{labels: '선택하세요', values: ''}
    let starty = moment().add(-5, 'Y').format('YYYY');
    let endy = moment().add(+5, 'Y').format('YYYY');
    for(let y = starty; y <= endy; y++){
        yearDatas.push({labels: y+'', values: y+''});
    }
    for(let m = 1; m <= 31; m++){
        let monthtxt = m < 10 ? '0'+m : m;
        monthDatas.push({labels: monthtxt+'', values: monthtxt+''});
    }
    for(let d = 1; d <= 31; d++){
        let daytxt = d < 10 ? '0'+d : d;
        dayDatas.push({labels: daytxt+'', values: daytxt+''});
    }
    const [memberinfos, setmemberinfos] = useState(''); 

    const [checkvalues, setcheckvalues] = useState([]);   
    const [checkvalues2, setcheckvalues2] = useState([]);   

    const [etcText1, setetcText1] = useState('');   //확인·설명근거자료 등 그밖
    const [etcText2, setetcText2] = useState('');   //권리관계 민간 임대 등록 여부 등록 그밖의유형
    const [etcText3, setetcText3] = useState('');   //입지조건 주차장 그밖
    const [etcText4, setetcText4] = useState('');   //비선호시설(1km이내) 그밖
    const [etcText5, setetcText5] = useState('');   //내부외부시설물의상태-수도-파손여부 위치
    const [etcText6, setetcText6] = useState('');   //내부외부시설물의상태-수도-용수량 위치
    const [etcText7, setetcText7] = useState('');   //내부외부시설물의상태-전기-공급상태 교체할 부분
    const [etcText8, setetcText8] = useState('');   //내부외부시설물의상태-가스-공급방식 그밖의방식
    const [etcText9, setetcText9] = useState('');   //내부외부시설물의상태-소방-단독경보형감지기 수량
    const [etcText10, setetcText10] = useState('');   //내부외부시설물의상태-난방방식및연료공급-시설작동 수선필요
    const [etcText11, setetcText11] = useState('');   //※개별공급인경우사용연한
    const [etcText12, setetcText12] = useState('');   //내부외부시설물의상태-난방방식및연료공급-종류 그밖의종류
    const [etcText13, setetcText13] = useState('');   //내부외부시설물의상태-배수 수선필요
    const [etcText14, setetcText14] = useState('');   //내부외부시설물의상태-배수-균열 위치
    const [etcText15, setetcText15] = useState('');   //내부외부시설물의상태-배수-누수 위치
    const [etcText16, setetcText16] = useState('');   //벽면바닥면및도배상태-바닥면 수리 필요
    const [etcText17, setetcText17] = useState('');   //환경조건-일조량 이유
    const [etcText18, setetcText18] = useState('');   //내부외부시설물의상태-소방-소화전 위치
    const [etcText19, setetcText19] = useState('');   //내부외부시설물의상태-소방-비상벨 위치



    const [inputArr, setinputArr] = useState([
        {keys: "건축물선택", values: '', requireCkr: true, errmsg: '건축물선택사항을 선택해주세요.'},
        {keys: "설명근거자료", values: '', requireCkr: true, errmsg: '확인·설명근거자료를 선택해주세요.'},
        {keys: "대상물건요구사항", values: '', requireCkr: false, errmsg: '확인·설명근거자료를 선택해주세요.'},
        {keys: "대상물건의표시-토지-소재지", values: '', requireCkr: true, errmsg: '대상물건의표시-토지-소재지를 입력해주세요.'},
        {keys: "대상물건의표시-토지-면적", values: '', requireCkr: true, errmsg: '대상물건의표시-토지-면적를 입력해주세요.'},
        {keys: "대상물건의표시-토지-지목-공부상지목", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-지목-공부상지목')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-지목-실제이용상태", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-지목-실제이용상태')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-전용면적", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-건축물-전용면적')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-대지지분", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-건축물-대지지분')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-준공년도", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-건축물-준공년도')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-건축물대장상용도", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-건축물-건축물대장상용도')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-실제용도", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-건축물-실제용도')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-구조", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-건축물-구조')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-방향", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-건축물-방향')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-기준", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-건축물-기준')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-내진설계적용여부", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-건축물-내진설계적용여부')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-내진능력", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-건축물-내진능력')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-위반건축물여부", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-건축물-위반건축물여부')+' 선택해주세요.'},
        {keys: "대상물건의표시-토지-건축물-위반내용", values: '', requireCkr: true, errmsg: heckName('대상물건의표시-토지-건축물-위반내용')+' 입력해주세요.'},
        {keys: "권리관계-등기부기재사항-소유권에관한사항-토지", values: '', requireCkr: true, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-토지')+' 입력해주세요.'},
        {keys: "권리관계-등기부기재사항-소유권외의권리사항-토지", values: '', requireCkr: true, errmsg: heckName('권리관계-등기부기재사항-소유권외의권리사항-토지')+' 입력해주세요.'},
        {keys: "권리관계-등기부기재사항-소유권에관한사항-건축물", values: '', requireCkr: true, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-건축물')+' 입력해주세요.'},
        {keys: "권리관계-등기부기재사항-소유권외의권리사항-건축물", values: '', requireCkr: true, errmsg: heckName('권리관계-등기부기재사항-소유권외의권리사항-건축물')+' 입력해주세요.'},
        {keys: "권리관계-민간임대등록여부-등록-선택사항", values: '', requireCkr: true, errmsg: heckName('권리관계-민간임대등록여부-등록-선택사항')+' 선택해주세요.'},
        {keys: "권리관계-민간임대등록여부-등록-임대의무기간", values: '', requireCkr: true, errmsg: heckName('권리관계-민간임대등록여부-등록-임대의무기간')+' 입력해주세요.'},
        {keys: "권리관계-민간임대등록여부-등록-임대개시일", values: '', requireCkr: true, errmsg: heckName('권리관계-민간임대등록여부-등록-임대개시일')+' 입력해주세요.'},
        {keys: "권리관계-민간임대등록여부-미등록", values: '', requireCkr: true, errmsg: heckName('권리관계-민간임대등록여부-미등록')+' 선택해주세요.'},
        {keys: "권리관계-계약갱신요구권행사여부", values: '', requireCkr: true, errmsg: heckName('권리관계-계약갱신요구권행사여부')+' 선택해주세요.'},
        {keys: "권리관계-다가구주택확인서류제출여부", values: '', requireCkr: false, errmsg: heckName('권리관계-다가구주택확인서류제출여부')+' 선택해주세요.'},
        {keys: "토지이용계획-지역지구-용도지역", values: '', requireCkr: true, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-지역·지구-용도지역')+' 입력해주세요.'},
        {keys: "토지이용계획-지역지구-용도지구", values: '', requireCkr: true, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-지역·지구-용도지구')+' 입력해주세요.'},
        {keys: "토지이용계획-지역지구-용도구역", values: '', requireCkr: true, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-지역·지구-용도구역')+' 입력해주세요.'},
        {keys: "토지이용계획-지역지구-건폐율상한", values: '', requireCkr: true, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-지역·지구-건폐율상한')+' 입력해주세요.'},
        {keys: "토지이용계획-지역지구-용적률상한", values: '', requireCkr: true, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-지역·지구-용적률상한')+' 입력해주세요.'},
        {keys: "토지이용계획-도시군계획시설", values: '', requireCkr: true, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-도시·군계획 시설')+' 입력해주세요.'},
        {keys: "토지이용계획-허가신고구역여부", values: '', requireCkr: true, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-허가·신고 구역 여부')+' 선택해주세요.'},
        {keys: "토지이용계획-투기지역여부", values: '', requireCkr: true, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-투기지역여부')+' 선택해주세요.'},
        {keys: "토지이용계획-지구단위계획구역", values: '', requireCkr: true, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-지구단위계획구역, 그 밖의 도시·군관리계획')+' 입력해주세요.'},
        {keys: "토지이용계획-그밖의이용제한", values: '', requireCkr: true, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-그 밖의 이용제한 및 거래규제사항')+' 입력해주세요.'},
        {keys: "입지조건-도로와의관계1", values: '', requireCkr: true, errmsg: heckName('입지조건-도로와의관계')+' 입력해주세요.'},
        {keys: "입지조건-도로와의관계2", values: '', requireCkr: true, errmsg: heckName('입지조건-도로와의관계')+' 입력해주세요.'},
        {keys: "입지조건-도로와의관계3", values: '', requireCkr: true, errmsg: heckName('입지조건-도로와의관계')+' 선택해주세요.'},
        {keys: "입지조건-도로와의관계-접근성", values: '', requireCkr: true, errmsg: heckName('입지조건-도로와의관계-접근성')+' 선택해주세요.'},
        {keys: "입지조건-대중교통-버스", values: '', requireCkr: true, errmsg: heckName('입지조건-대중교통-버스')+' 입력해주세요.'},
        {keys: "입지조건-대중교통-버스2", values: '', requireCkr: true, errmsg: heckName('입지조건-대중교통-버스')+' 선택해주세요.'},
        {keys: "입지조건-대중교통-버스3", values: '', requireCkr: true, errmsg: heckName('입지조건-대중교통-버스')+' 입력해주세요.'},
        {keys: "입지조건-대중교통-지하철1", values: '', requireCkr: true, errmsg: heckName('입지조건-대중교통-지하철')+' 입력해주세요.'},
        {keys: "입지조건-대중교통-지하철2", values: '', requireCkr: true, errmsg: heckName('입지조건-대중교통-지하철')+' 선택해주세요.'},
        {keys: "입지조건-대중교통-지하철3", values: '', requireCkr: true, errmsg: heckName('입지조건-대중교통-지하철')+' 입력해주세요.'},
        {keys: "입지조건-주차장1", values: '', requireCkr: true, errmsg: heckName('입지조건-주차장')+' 선택해주세요.'},
        {keys: "입지조건-교육시설-초등학교1", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-초등학교')+' 입력해주세요.'},
        {keys: "입지조건-교육시설-초등학교2", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-초등학교')+' 선택해주세요.'},
        {keys: "입지조건-교육시설-초등학교3", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-초등학교')+' 입력해주세요.'},
        {keys: "입지조건-교육시설-중학교1", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-중학교')+' 입력해주세요.'},
        {keys: "입지조건-교육시설-중학교2", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-중학교')+' 선택해주세요.'},
        {keys: "입지조건-교육시설-중학교3", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-중학교')+' 입력해주세요.'},
        {keys: "입지조건-교육시설-고등학교1", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-고등학교')+' 입력해주세요.'},
        {keys: "입지조건-교육시설-고등학교2", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-고등학교')+' 선택해주세요.'},
        {keys: "입지조건-교육시설-고등학교3", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-고등학교')+' 입력해주세요.'},
        {keys: "입지조건-판매및의료시설-백화점및할인매장1", values: '', requireCkr: false, errmsg: heckName('입지조건-판매및의료시설-백화점 및 할인매장')+' 입력해주세요.'},
        {keys: "입지조건-판매및의료시설-백화점및할인매장2", values: '', requireCkr: false, errmsg: heckName('입지조건-판매및의료시설-백화점 및 할인매장')+' 선택해주세요.'},
        {keys: "입지조건-판매및의료시설-백화점및할인매장3", values: '', requireCkr: false, errmsg: heckName('입지조건-판매및의료시설-백화점 및 할인매장')+' 입력해주세요.'},
        {keys: "입지조건-판매및의료시설-종합의료시설1", values: '', requireCkr: false, errmsg: heckName('입지조건-판매및의료시설-종합의료시설')+' 입력해주세요.'},
        {keys: "입지조건-판매및의료시설-종합의료시설2", values: '', requireCkr: false, errmsg: heckName('입지조건-판매및의료시설-종합의료시설')+' 선택해주세요.'},
        {keys: "입지조건-판매및의료시설-종합의료시설3", values: '', requireCkr: false, errmsg: heckName('입지조건-판매및의료시설-종합의료시설')+' 입력해주세요.'},
        {keys: "관리에관한사항-경비실", values: '', requireCkr: true, errmsg: heckName('관리에관한사항-경비실')+' 선택해주세요.'},
        {keys: "관리에관한사항-관리주체", values: '', requireCkr: true, errmsg: heckName('관리에관한사항-관리주체')+' 선택해주세요.'},
        {keys: "비선호시설", values: '', requireCkr: false, errmsg: heckName('비선호시설')+' 선택해주세요.'},
        {keys: "거래예정금액", values: '', requireCkr: true, errmsg: heckName('거래예정금액')+' 입력해주세요.'},
        {keys: "개별공시지가", values: '', requireCkr: true, errmsg: heckName('개별공시지가')+' 입력해주세요.'},
        {keys: "건물주택공시가격", values: '', requireCkr: true, errmsg: heckName('건물주택공시가격')+' 입력해주세요.'},
        {keys: "취득세", values: '', requireCkr: true, errmsg: heckName('취득세')+' 입력해주세요.'},
        {keys: "농어촌특별세", values: '', requireCkr: true, errmsg: heckName('농어촌특별세')+' 입력해주세요.'},
        {keys: "지방교육세", values: '', requireCkr: true, errmsg: heckName('지방교육세')+' 입력해주세요.'},
        {keys: "실제권리관계또는공시되지않은물건의권리사항", values: '', requireCkr: true, errmsg: heckName('실제권리관계또는공시되지않은물건의권리사항')+' 입력해주세요.'},
        {keys: "내부외부시설물의상태-수도-파손여부", values: '', requireCkr: true, errmsg: heckName('내부외부시설물의상태-수도-파손여부')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-수도-용수량", values: '', requireCkr: true, errmsg: heckName('내부외부시설물의상태-수도-용수량')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-전기-공급상태", values: '', requireCkr: true, errmsg: heckName('내부외부시설물의상태-전기-공급상태')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-가스-공급방식", values: '', requireCkr: true, errmsg: heckName('내부외부시설물의상태-가스-공급방식')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-소방-단독경보형감지기", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-소방-단독경보형감지기')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-소방-소화전", values: '', requireCkr: true, errmsg: heckName('내부외부시설물의상태-소방-소화전')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-소방-비상벨", values: '', requireCkr: true, errmsg: heckName('내부외부시설물의상태-소방-비상벨')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-난방방식및연료공급-공급방식", values: '', requireCkr: true, errmsg: heckName('내부외부시설물의상태-난방방식및연료공급-공급방식')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-난방방식및연료공급-시설작동", values: '', requireCkr: true, errmsg: heckName('내부외부시설물의상태-난방방식및연료공급-시설작동')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-난방방식및연료공급-종류", values: '', requireCkr: true, errmsg: heckName('내부외부시설물의상태-난방방식및연료공급-종류')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-승강기", values: '', requireCkr: true, errmsg: heckName('내부외부시설물의상태-승강기')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-배수", values: '', requireCkr: true, errmsg: heckName('내부외부시설물의상태-배수')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-그밖의시설물", values: '', requireCkr: true, errmsg: heckName('내부외부시설물의상태-그밖의시설물')+' 선택해주세요.'},
        {keys: "벽면바닥면및도배상태-벽면-균열", values: '', requireCkr: true, errmsg: heckName('벽면바닥면및도배상태-벽면-균열')+' 선택해주세요.'},
        {keys: "벽면바닥면및도배상태-벽면-누수", values: '', requireCkr: true, errmsg: heckName('벽면바닥면및도배상태-벽면-누수')+' 선택해주세요.'},
        {keys: "벽면바닥면및도배상태-바닥면", values: '', requireCkr: true, errmsg: heckName('벽면바닥면및도배상태-바닥면')+' 선택해주세요.'},
        {keys: "벽면바닥면및도배상태-도배", values: '', requireCkr: false, errmsg: heckName('벽면바닥면및도배상태-도배')+' 선택해주세요.'},
        {keys: "환경조건-일조량", values: '', requireCkr: true, errmsg: heckName('환경조건-일조량')+' 선택해주세요.'},
        {keys: "환경조건-소음", values: '', requireCkr: true, errmsg: heckName('환경조건-소음')+' 선택해주세요.'},
        {keys: "환경조건-진동", values: '', requireCkr: true, errmsg: heckName('환경조건-진동')+' 선택해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-중개보수", values: '', requireCkr: true, errmsg: heckName('중개보수및실비의금액과산출내역-중개보수')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-작성일반중개보수", values: '', requireCkr: false, errmsg: heckName('중개보수및실비의금액과산출내역-작성일반중개보수')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-작성일반실비", values: '', requireCkr: false, errmsg: heckName('중개보수및실비의금액과산출내역-작성일반실비')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-산출내역중개보수", values: '', requireCkr: true, errmsg: heckName('중개보수및실비의금액과산출내역-산출내역중개보수')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-산출내역실비", values: '', requireCkr: true, errmsg: heckName('중개보수및실비의금액과산출내역-산출내역실비')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-실비", values: '', requireCkr: true, errmsg: heckName('중개보수및실비의금액과산출내역-실비')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-계", values: '', requireCkr: true, errmsg: heckName('중개보수및실비의금액과산출내역-계')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-지급시기", values: '', requireCkr: true, errmsg: heckName('중개보수및실비의금액과산출내역-지급시기')+' 입력해주세요.'},
        {keys: "수령일년", values: moment().format('YYYY'), requireCkr: true, errmsg: heckName('수령일년')+' 선택해주세요.'},
        {keys: "수령일월", values: moment().format('MM'), requireCkr: true, errmsg: heckName('수령일월')+' 선택해주세요.'},
        {keys: "수령일일", values: moment().format('DD'), requireCkr: true, errmsg: heckName('수령일일')+' 선택해주세요.'},
        {keys: "매도인주소", values: '', requireCkr: true, errmsg: heckName('매도/임대 주소를')+' 입력해주세요.'},
        {keys: "매도인주민번호", values: '', requireCkr: true, errmsg: heckName('매도/임대 생년월일')+' 입력해주세요.'},
        {keys: "매도인전화", values: '', requireCkr: true, errmsg: heckName('매도/임대 전화번호')+' 입력해주세요.'},
        {keys: "매수인주소", values: '', requireCkr: true, errmsg: heckName('매수/임차 주소')+' 입력해주세요.'},
        {keys: "매수인주민번호", values: '', requireCkr: true, errmsg: heckName('매수/임차 생년월일')+' 입력해주세요.'},
        {keys: "매수인전화", values: '', requireCkr: true, errmsg: heckName('매수/임차 전화번호')+' 입력해주세요.'},
        {keys: "개중등록번호1", values: '', requireCkr: true, errmsg: heckName('개업공인중개사 등록번호')+' 입력해주세요.'},
        {keys: "개중사무소명칭1", values: '', requireCkr: true, errmsg: heckName('개업공인중개사 사무소명칭')+' 입력해주세요.'},
        {keys: "개중사무소소재지1", values: '', requireCkr: true, errmsg: heckName('개업공인중개사 사무소소재지')+' 입력해주세요.'},
        {keys: "개중소속공인중개사1", values: '', requireCkr: true, errmsg: heckName('개업공인중개사 소속공인중개사')+' 입력해주세요.'},
        {keys: "개중전화번호1", values: '', requireCkr: true, errmsg: heckName('개업공인중개사 전화번호')+' 입력해주세요.'},
        {keys: "개중등록번호2", values: '', requireCkr: true, errmsg: heckName('공동 개업공인중개사 등록번호')+' 입력해주세요.'},
        {keys: "개중사무소명칭2", values: '', requireCkr: true, errmsg: heckName('공동 개업공인중개사 사무소명칭')+' 입력해주세요.'},
        {keys: "개중사무소소재지2", values: '', requireCkr: true, errmsg: heckName('공동 개업공인중개사 사무소소재지')+' 입력해주세요.'},
        {keys: "개중소속공인중개사2", values: '', requireCkr: true, errmsg: heckName('공동 개업공인중개사 소속공인중개사')+' 입력해주세요.'},
        {keys: "개중전화번호2", values: '', requireCkr: true, errmsg: heckName('공동 개업공인중개사 전화번호')+' 입력해주세요.'},
    ]);
    
    
    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    useEffect(() => {
        if(row?.confirmation){
            console.log(row);

            let confirmArr = JSON?.parse(row?.confirmation);
            let inputArrData = confirmArr[0]?.inputs;
            console.log(inputArrData);
            // console.log(inputArrData?.find(item => item?.keys === '공동중개여부')?.values);
            setetcText1(confirmArr[0]?.etcText1);
            setetcText2(confirmArr[0]?.etcText2);
            setetcText3(confirmArr[0]?.etcText3);
            setetcText4(confirmArr[0]?.etcText4);
            setetcText5(confirmArr[0]?.etcText5);
            setetcText6(confirmArr[0]?.etcText6);
            setetcText7(confirmArr[0]?.etcText7);
            setetcText8(confirmArr[0]?.etcText8);
            setetcText9(confirmArr[0]?.etcText9);
            setetcText10(confirmArr[0]?.etcText10);
            setetcText11(confirmArr[0]?.etcText11);
            setetcText12(confirmArr[0]?.etcText12);
            setetcText13(confirmArr[0]?.etcText13);
            setetcText14(confirmArr[0]?.etcText14);
            setetcText15(confirmArr[0]?.etcText15);
            setetcText16(confirmArr[0]?.etcText16);
            setetcText17(confirmArr[0]?.etcText17);
            setetcText18(confirmArr[0]?.etcText18);
            setetcText19(confirmArr[0]?.etcText19);
            if(inputArrData){
                setinputArr(inputArrData);
                if(inputArrData?.find(item => item?.keys === '설명근거자료')?.values){
                    setcheckvalues(inputArrData?.find(item => item?.keys === '설명근거자료')?.values);
                } else {
                    setcheckvalues([]);
                }
                if(inputArrData?.find(item => item?.keys === '권리관계-민간임대등록여부-미등록')?.values){
                    setcheckvalues2(inputArrData?.find(item => item?.keys === '권리관계-민간임대등록여부-미등록')?.values);
                } else {
                    setcheckvalues2([]);
                }
            }
        } else {
            
        }
    }, [row]);
    
    let subarrheight = 0;
    let commentcount = 0;
    let buyercount = 1;
    let sellercount = 1;
    let togethercount = 1;

    inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가')?.values?.map((x, i) => { subarrheight = subarrheight+598; });
    inputArr?.find(item => item?.keys === '매도인')?.values?.map((x, i) => { if(i > 0) subarrheight = subarrheight+70; });
    inputArr?.find(item => item?.keys === '매수인')?.values?.map((x, i) => { if(i > 0) subarrheight = subarrheight+70; });
    inputArr?.find(item => item?.keys === '공동중개')?.values?.map((x, i) => { if(i > 0) subarrheight = subarrheight+105; });

    let commentlength = inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가')?.values?.length;
    subarrheight = (subarrheight+40)+(Math.ceil(subarrheight/1116)*279)+(commentlength+239);
    let subpagecount = Math.ceil(subarrheight/1116);
    let pageArr = [];
    for(let p = 0; p < subpagecount; p++){
        pageArr.push({page: p+1});
    }

    console.log(pageArr, subpagecount, subarrheight);
    let colorarr = ['yellow','green','blue','orange','purple','lightblue','lighegreen','','','','','',''];

    return (
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', gap: 10}}>
            <div>
                ■ 공인중개사법 시행규칙 [별지 제20호서식] &lt;<span style={{ color: 'blue' }}>개정 2021. 12. 31.</span>&gt;
            </div>
            <div 
                className='fontsize12' 
                style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 8,
                    flexDirection: 'column', marginTop: 7, marginBottom: 7
                }}
            >
  
                <div className='bolds fontsize24'>
                    <b style={{ fontWeight: 800 }} className='fontsize24'>중개대상물 확인ᆞ설명서[II]</b> (비주거용 건축물)         
                    ({inputArr?.find(item => item?.keys === '건축물선택')?.values})            
                </div>
            </div>
            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>확인·설명<br />자료</td>
                        <td colSpan={4} className='alignc'>확인·설명<br />근거자료 등</td>
                        <td colSpan={23} style={{ borderRightWidth: 0 }}>
                        {checkvalues?.map(item => item.names)?.join(", ")}
                        {checkvalues?.find(item => item?.values*1 === 7) ? "("+etcText1+")" : ''}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4} className='alignc'>대상물건의<br />상태에 관한<br />자료요구 사항</td>
                        <td colSpan={23} style={{ borderRightWidth: 0 }} >
                        {inputArr?.find(item => item?.keys === '대상물건요구사항')?.values}
                        </td>
                    </tr>
                </table>
            </div>  
            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <th colSpan={12} className='alignc' style={{ borderLeftWidth: 0, borderRightWidth: 0, height: 40 }} >유의사항</th>
                    </tr>
                    <tr style={{ height: 80 }}>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0, width: 100, }}>개업공인중개사의 확인·설명 의무</td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }}>개업공인중개사는 중개대상물에 관한 권리를 취득하려는 중개의뢰인에게 성실ᆞ정확하게 설명하고, 토지대장 등본, 등기사항증명서 등 설명의 근거자료를 제시해야 합니다.</td>
                    </tr>
                    <tr style={{ height: 91 }}>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0, width: 100 }}>실제 거래가격 신고</td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }}>「부동산 거래신고 등에 관한 법률」 제3조 및 같은 법 시행령 별표 1 제1호마목에 따른 실제 거래가격은 매수인이 매수한 부동산을 양도하는 경우 「소득세법」 제97조제1항 및 제7항과 같은 법 시행령 제163조제11항제2호에 따라 취득 당시의 실제 거래가액으로 보아 양도차익이 계산될 수 있음을 유의하시기 바랍니다.</td>
                    </tr>
                </table>
            </div>        

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={30} style={{ borderLeftWidth: 0, borderRightWidth: 0, height: 40 }} className='bolds'>I. 개업공인중개사 기본 확인사항</td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={9}>① 대상물건의 표시</td>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>토지</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }}>소재지</td>
                        <td colSpan={22} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '대상물건의표시-토지-소재지')?.values}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>면적(m²)</td>
                        <td colSpan={8} rowSpan={2}>
                            {inputArr?.find(item => item?.keys === '대상물건의표시-토지-면적')?.values}                         
                        </td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>지목</td>
                        <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }}>공부상 지목</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '대상물건의표시-토지-지목-공부상지목')?.values}                        
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }}>실제 이용 상태</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '대상물건의표시-토지-지목-실제이용상태')?.values}                     
                        </td>
                    </tr>

                    <tr>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={6}>건축물</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }}>전용면적(m²)</td>
                        <td colSpan={11} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-전용면적')?.values}                        
                        </td>
                        <td colSpan={4} className='alignc' >대지지분(m²)</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-대지지분')?.values}                      
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>준공년도<br />(증개축년도)</td>
                        <td colSpan={8} rowSpan={2}>
                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-준공년도')?.values}                          
                        </td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>용도</td>
                        <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }}>건축물대장상 용도</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-건축물대장상용도')?.values}                         
                        </td>
                    </tr>          
                    <tr>
                        <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }}>실제 용도</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-실제용도')?.values}                           
                        </td>
                    </tr>    
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }}>구조</td>
                        <td colSpan={8} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-구조')?.values}                            
                        </td>
                        <td colSpan={5} className='alignc' >방향</td>
                        <td colSpan={9} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                <div>
                                {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-방향')?.values}                             
                                </div>
                                <div className='' style={{ gap: 4 }}>
                                    <span style={{ width: 40 }}>(기준 : {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-기준')?.values})</span>
                                </div>
                            </div>
                        </td>
                    </tr>   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, fontSize: 11, letterSpacing: -1 }}>내진설계 적용여부</td>
                        <td colSpan={8} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-내진설계적용여부')?.values}
                        </td>
                        <td colSpan={7} className='alignc' >내진능력</td>
                        <td colSpan={7} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-내진능력')?.values}
                        </td>
                    </tr>                      
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, fontSize: 12, letterSpacing: -1 }}>건축물대장상<br />위반건축물 여부</td>
                        <td colSpan={8} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-위반건축물여부')?.values}                              
                        </td>
                        <td colSpan={3} className='alignc' >위반내용</td>
                        <td colSpan={11} style={{ borderRightWidth: 0, }}>
                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-위반내용')?.values}
                        </td>
                    </tr>                     
                </table>
            </div>    

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={8}>② 권리관계</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>등기부 기재사항</td>
                        <td colSpan={12} className='alignc' style={{ borderLeftWidth: 0 }}>소유권에 관한 사항</td>
                        <td colSpan={12} className='alignc' style={{ borderRightWidth: 0 }}>소유권 외의 권리사항</td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >토지</td>
                        <td colSpan={9} style={{ borderRightWidth: 0, whiteSpace: 'pre-wrap' }}>
                        {inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지')?.values}                           
                        </td>
                        <td colSpan={3} className='alignc' >토지</td>
                        <td colSpan={9} style={{ borderRightWidth: 0, whiteSpace: 'pre-wrap' }}>
                        {inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권외의권리사항-토지')?.values}                         
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >건축물</td>
                        <td colSpan={9} style={{ borderRightWidth: 0, whiteSpace: 'pre-wrap' }}>
                        {inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-건축물')?.values}                            
                        </td>
                        <td colSpan={3} className='alignc' >건축물</td>
                        <td colSpan={9} style={{ borderRightWidth: 0, whiteSpace: 'pre-wrap' }}>
                        {inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권외의권리사항-건축물')?.values}                          
                        </td>
                    </tr>

                    <tr>
                        <td colSpan={1} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>민간 임대 등록 여부</td>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>등록</td>
                        <td colSpan={24} className='' style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '권리관계-민간임대등록여부-등록-선택사항')?.values}
                            {inputArr?.find(item => item?.names === '그 밖의 유형') ? "("+etcText2+")" : ''}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5} className='alignc' style={{ borderLeftWidth: 0 }} >임대의무기간</td>
                        <td colSpan={7} className='' style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '권리관계-민간임대등록여부-등록-임대의무기간')?.values}
                        </td>
                        <td colSpan={5} className='alignc' style={{ wordBreak: 'keep-all' }} >임대개시일</td>
                        <td colSpan={7} className='' style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '권리관계-민간임대등록여부-등록-임대개시일')?.values}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0 }} >미등록</td>
                        <td colSpan={24} className='' style={{ borderRightWidth: 0 }}>
                            {checkvalues2?.map(item => item.names)?.join(", ")}
                        </td>
                    </tr>

                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >계약갱신 요구권 행사 여부</td>
                        <td colSpan={24} className='' style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '권리관계-계약갱신요구권행사여부')?.values}
                        </td>
                    </tr>

                </table>
            </div>
            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={6}>③ 토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항(토지)</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>지역·지구</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >용도지역</td>
                        <td colSpan={15} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '토지이용계획-지역지구-용도지역')?.values}                          
                        </td>
                        <td colSpan={3} className='alignc' >건폐율 상한</td>
                        <td colSpan={3} className='alignc' style={{ borderRightWidth: 0 }}>용적률 상한</td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >용도지구</td>
                        <td colSpan={15} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '토지이용계획-지역지구-용도지구')?.values}
                        </td>
                        <td colSpan={3} className='alignc' style={{ borderRightWidth: 0 }} rowSpan={2}>
                        {inputArr?.find(item => item?.keys === '토지이용계획-지역지구-건폐율상한')?.values}
                        </td>
                        <td colSpan={3} className='alignc' style={{ borderRightWidth: 0 }} rowSpan={2}>
                        {inputArr?.find(item => item?.keys === '토지이용계획-지역지구-용적률상한')?.values}                     
                        </td>

                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >용도구역</td>
                        <td colSpan={15} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '토지이용계획-지역지구-용도구역')?.values}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>도시·군계획 시설</td>
                        <td colSpan={9} style={{ borderRightWidth: 0 }} rowSpan={2}>
                        {inputArr?.find(item => item?.keys === '토지이용계획-도시군계획시설')?.values}
                        </td>
                        <td colSpan={3} className='alignc' >허가·신고 구역 여부</td>
                        <td colSpan={12} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '토지이용계획-허가신고구역여부')?.values}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' >투기지역 여부</td>
                        <td colSpan={12} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '토지이용계획-투기지역여부')?.values}
                        </td>
                    </tr>

                    <tr>
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 0 }} >지구단위계획구역,<br />그 밖의 도시·군관리계획</td>
                        <td colSpan={8} className='' style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '토지이용계획-지구단위계획구역')?.values}
                        </td>
                        <td colSpan={5} className='alignc' >그 밖의 이용제한 및 거래규제사항</td>
                        <td colSpan={8} className='' style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '토지이용계획-그밖의이용제한')?.values}
                        </td>
                    </tr>
                </table>
            </div>
            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={9}>④ 입지조건</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >도로와의 관계</td>
                        <td colSpan={16} style={{ borderRightWidth: 0 }}> 
                                ({inputArr?.find(item => item?.keys === '입지조건-도로와의관계1')?.values}m
                                x {inputArr?.find(item => item?.keys === '입지조건-도로와의관계2')?.values}m
                                )
                                도로에접함 {inputArr?.find(item => item?.keys === '입지조건-도로와의관계3')?.values}
                        </td>
                        <td colSpan={2} className='alignc' >접근성</td>
                        <td colSpan={6} className='alignc' style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '입지조건-도로와의관계-접근성')?.values}
                        </td>
                    </tr>
                    
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>대중교통</td>
                        <td colSpan={3} className='alignc' >버스</td>
                        <td colSpan={21} className='' style={{ borderRightWidth: 0 }}>
                                (
                                    {inputArr?.find(item => item?.keys === '입지조건-대중교통-버스')?.values}
                                )
                                정류장, 
                                소요시간: (
                                    {inputArr?.find(item => item?.keys === '입지조건-대중교통-버스2')?.values}
                                )
                                약 
                                {inputArr?.find(item => item?.keys === '입지조건-대중교통-버스3')?.values}분                              
                        </td>
                    </tr>
                    
                    <tr>
                        <td colSpan={3} className='alignc' >지하철</td>
                        <td colSpan={21} className='' style={{ borderRightWidth: 0 }}>
                            ({inputArr?.find(item => item?.keys === '입지조건-대중교통-지하철1')?.values})역, 
                            소요시간: ({inputArr?.find(item => item?.keys === '입지조건-대중교통-지하철2')?.values} )
                            약 {inputArr?.find(item => item?.keys === '입지조건-대중교통-지하철3')?.values}분                     
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >주차장</td>
                        <td colSpan={24} className='' style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '입지조건-주차장1')?.values}
                            {inputArr?.find(item => item?.keys === '입지조건-주차장1')?.values === '그밖의주차시설' ? "("+etcText3+")" : ''}
                        </td>
                    </tr>
                </table>
            </div>

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >⑤ 관리에 관한사항</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >경비실</td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '관리에관한사항-경비실')?.values}
                        </td>
                        <td colSpan={3} className='alignc' >관리주체</td>
                        <td colSpan={11} className='' style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '관리에관한사항-관리주체')?.values}                        
                        </td>
                    </tr>
                </table>
            </div>
            
            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={5} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>⑥ 거래예정금액 등</td>
                        <td colSpan={5} className='alignc' style={{ borderLeftWidth: 0 }} >거래예정금액</td>
                        <td colSpan={20} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '거래예정금액')?.values}                        
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5} className='alignc' style={{ borderLeftWidth: 0 }} >개별공시지가(m²당)</td>
                        <td colSpan={5} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '개별공시지가')?.values}
                        </td>
                        <td colSpan={5} className='alignc' >건물(주택) 공시가격</td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '건물주택공시가격')?.values}
                        </td>
                    </tr>
                </table>
            </div>

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={5} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>⑦ 취득 시 부담할 조세의 종류 및 세율</td>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0 }} >취득세</td>
                        <td colSpan={5} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '취득세')?.values}                      
                        </td>
                        <td colSpan={3} className='alignc' >농어촌특별세</td>
                        <td colSpan={5} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '농어촌특별세')?.values}                       
                        </td>
                        <td colSpan={3} className='alignc' >지방교육세</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '지방교육세')?.values}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={25} style={{ borderRightWidth: 0 }}>※ 재산세와 종합부동산세는 6월 1일 기준 대상물건 소유자가 납세의무를 부담</td>
                    </tr>
                </table>
            </div>



            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={30} style={{ borderLeftWidth: 0, borderRightWidth: 0 }} className='bolds'>II. 개업공인중개사 세부 확인사항</td>
                    </tr>
                    <tr>
                        <td colSpan={30} style={{ border: 0 }} >⑧ 실제 권리관계 또는 공시되지 않은물건의 권리 사항</td>
                    </tr>
                    <tr>
                        <td colSpan={30} style={{ border: 0, height: 250, verticalAlign: 'top'}}>
                        {inputArr?.find(item => item?.keys === '실제권리관계또는공시되지않은물건의권리사항')?.values}         
                        </td>
                    </tr>             
                </table>
            </div>  

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={11}>⑨ 내부· 외부 시설물 의상태 (건축물)</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>수도</td>
                        <td colSpan={3} className='alignc' >파손 여부</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-수도-파손여부')?.values}
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-수도-파손여부')?.values === '있음' ? "(위치 : "+etcText5+")" : ''}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' >용수량</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-수도-용수량')?.values}
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-수도-용수량')?.values === '부족함' ? "(위치 : "+etcText6+")" : ''}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >전기</td>
                        <td colSpan={3} className='alignc' >공급상태</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-전기-공급상태')?.values}
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-전기-공급상태')?.values === '교체 필요' ? "(교체할부분 : "+etcText7+")" : ''}
                        </td>
                    </tr>                    
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >가스(취사용)</td>
                        <td colSpan={3} className='alignc' >공급방식</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-가스-공급방식')?.values}
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-가스-공급방식')?.values === '그밖의방식' ? "(교체할부분 : "+etcText8+")" : ''}
                        </td>
                    </tr>                 
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>소방</td>
                        <td colSpan={3} className='alignc' >소화전</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-소방-소화전')?.values}
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-소방-소화전')?.values === '있음' ? "(위치 : "+etcText18+")" : ''}
                        </td>
                    </tr>      
                    <tr>
                        <td colSpan={3} className='alignc' >비상벨</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-소방-비상벨')?.values}
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-소방-비상벨')?.values === '있음' ? "(위치 : "+etcText19+")" : ''}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>난방방식 및 연료공급</td>
                        <td colSpan={3} className='alignc' >공급방식</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-공급방식')?.values}
                        </td>
                        <td colSpan={2} className='alignc' >시설작동</td>
                        <td colSpan={12} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-시설작동')?.values}&nbsp;
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-시설작동')?.values === '수선필요' ? "("+etcText10+")개" : ''}
                            ※개별공급인경우사용연한({etcText11})
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' >종류</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-종류')?.values}
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-종류')?.values === '그밖의종류' ? "("+etcText12+")" : ''}
                        </td>
                    </tr>       
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >승강기</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '내부외부시설물의상태-승강기')?.values}
                        </td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >배수</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-배수')?.values}
                            {inputArr?.find(item => item?.keys === '내부외부시설물의상태-배수')?.values === '수선필요' ? "("+etcText13+")" : ''}
                        </td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >그 밖의 시설물</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '내부외부시설물의상태-그밖의시설물')?.values}
                        </td>
                    </tr>                                                   
                </table>
            </div>


            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={4}>⑩ 벽면ᆞ 바닥면 및 도배 상태</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>벽면</td>
                        <td colSpan={3} className='alignc' >균열</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '벽면바닥면및도배상태-벽면-균열')?.values}
                            {inputArr?.find(item => item?.keys === '벽면바닥면및도배상태-벽면-균열')?.values === '있음' ? "("+etcText14+")" : ''}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' >누수</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '벽면바닥면및도배상태-벽면-누수')?.values}
                            {inputArr?.find(item => item?.keys === '벽면바닥면및도배상태-벽면-누수')?.values === '있음' ? "("+etcText15+")" : ''}
                        </td>
                    </tr>
                     
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >바닥면</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '벽면바닥면및도배상태-바닥면')?.values}
                            {inputArr?.find(item => item?.keys === '벽면바닥면및도배상태-바닥면')?.values === '수리 필요' ? "("+etcText16+")" : ''}
                        </td>
                    </tr>                                                 
                                                              
                </table>
            </div>


            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>⑫ 환경 조건</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >일조량</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                            {inputArr?.find(item => item?.keys === '환경조건-일조량')?.values}
                            {inputArr?.find(item => item?.keys === '환경조건-일조량')?.values === '불충분' ? "("+etcText17+")" : ''}
                        </td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >소음</td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '환경조건-소음')?.values}
                        </td>
                        <td colSpan={3} className='alignc' >진동</td>
                        <td colSpan={11} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '환경조건-진동')?.values}
                        </td>
                    </tr>                                                      
                </table>
            </div>

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={30} style={{ borderLeftWidth: 0, borderRightWidth: 0 }} className='bolds'>III. 중개보수 등에 관한 사항</td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={4}>⑪ 중개보수 및 실비의 금액과 산출내역</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >중개보수</td>
                        <td colSpan={14} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '중개보수및실비의금액과산출내역-중개보수')?.values}
                        </td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }} rowSpan={4}>
                            <div className='bolds'>&lt;산출내역&gt;</div>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                중개보수 : {inputArr?.find(item => item?.keys === '중개보수및실비의금액과산출내역-산출내역중개보수')?.values}
                            </div>
                            <div className='displayflexstart' style={{ gap: 4, marginTop: 3 }}>
                                실　　비 : {inputArr?.find(item => item?.keys === '중개보수및실비의금액과산출내역-산출내역실비')?.values}
                            </div>
                        </td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >실비</td>
                        <td colSpan={14} style={{ borderRightWidth: 0 }}> 
                        {inputArr?.find(item => item?.keys === '중개보수및실비의금액과산출내역-실비')?.values}  
                        </td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >계</td>
                        <td colSpan={14} style={{ borderRightWidth: 0 }}> 
                        {inputArr?.find(item => item?.keys === '중개보수및실비의금액과산출내역-계')?.values}
                        </td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >지급시기</td>
                        <td colSpan={14} style={{ borderRightWidth: 0 }}> 
                        {inputArr?.find(item => item?.keys === '중개보수및실비의금액과산출내역-지급시기')?.values}
                        </td>
                    </tr>                                                   
                </table>
            </div>

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={30} style={{ borderLeftWidth: 0, borderRightWidth: 0 }} >
                            <p style={{ fontSize: 12 }}>「공인중개사법」 제25조제3항 및 제30조제5항에 따라 거래당사자는 개업공인중개사로부터 위 중개대상물에 관한 확인·설명 및 손해배상책임의 보장에 관한 설명을 듣고, 같은 법 시행령 제21조제3항에 따른 본 확인·설명서와 같은 법 시행령 제24조제 2항에 따른 손해배상책임 보장 증명서류(사본 또는 전자문서)를 수령합니다.</p>
                            <div style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 5,
                                marginTop: 15
                            }}>
                                {inputArr?.find(item => item?.keys === '수령일년')?.values}년&nbsp;
                                {inputArr?.find(item => item?.keys === '수령일월')?.values}월&nbsp;
                                {inputArr?.find(item => item?.keys === '수령일일')?.values}일                                    
                            </div>
                        </td>
                    </tr>
                                        {inputArr?.find(item => item?.keys === '매도인')?.values?.map((x, i) => {
                        let indexNumber = i;
                        if(i > 0) return;         
                        return (
                        <>

                    
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} rowSpan={2}>매도인 (임대인)</td>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >주소</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                {x?.values?.find(item => item?.keys === '매도인주소')?.values}
                                {x?.subflag &&
                                    <><br />{x?.values?.find(item => item?.keys === '대리인주소')?.values}</>
                                }
                            </td>
                            <td colSpan={3} className='alignc' >성명</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                (서명 또는 날인)
                                {x?.subflag &&
                                <><br />(서명 또는 날인)</>
                                }                                
                            </td>
                        </tr>                                                   
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >생년월일</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                {x?.values?.find(item => item?.keys === '매도인주민번호')?.values}
                                {x?.subflag &&
                                    <><br />{x?.values?.find(item => item?.keys === '대리인주민번호')?.values}</>
                                }
                            </td>
                            <td colSpan={3} className='alignc' >전화번호</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right', height: 35 }}>
                                {x?.values?.find(item => item?.keys === '매도인전화')?.values}
                                {x?.subflag &&
                                    <><br />{x?.values?.find(item => item?.keys === '대리인전화')?.values}</>
                                }
                            </td>
                        </tr>        
                        </>
                        );
                    })}      

                    {inputArr?.find(item => item?.keys === '매수인')?.values?.map((x, i) => {
                        let indexNumber = i;
                        if(i > 0) return;         
                        return (
                        <>

                    
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} rowSpan={2}>매수인 (임차인)</td>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >주소</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                {x?.values?.find(item => item?.keys === '매수인주소')?.values}
                                {x?.subflag &&
                                    <><br />{x?.values?.find(item => item?.keys === '대리인주소')?.values}</>
                                }
                            </td>
                            <td colSpan={3} className='alignc' >성명</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                (서명 또는 날인)
                                {x?.subflag &&
                                <><br />(서명 또는 날인)</>
                                }                                
                            </td>
                        </tr>                                                   
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >생년월일</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                {x?.values?.find(item => item?.keys === '매수인주민번호')?.values}
                                {x?.subflag &&
                                    <><br />{x?.values?.find(item => item?.keys === '대리인주민번호')?.values}</>
                                }
                            </td>
                            <td colSpan={3} className='alignc' >전화번호</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                {x?.values?.find(item => item?.keys === '매수인전화')?.values}
                                {x?.subflag &&
                                    <><br />{x?.values?.find(item => item?.keys === '대리인전화')?.values}</>
                                }
                            </td>
                        </tr>        
                        </>
                        );
                    })}

                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} rowSpan={3}>개업 공인중개사</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >등록번호</td>
                        <td colSpan={11} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '개중등록번호1')?.values}
                        </td>
                        <td colSpan={3} className='alignc' >성명 (대표자)</td>
                        <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>(서명 및 날인)</td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >사무소 명칭</td>
                        <td colSpan={11} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '개중사무소명칭1')?.values}
                        </td>
                        <td colSpan={3} className='alignc' >소속 공인중개사</td>
                        <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                        {inputArr?.find(item => item?.keys === '개중소속공인중개사1')?.values}
                        </td>
                    </tr>  
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >사무소 소재지</td>
                        <td colSpan={11} style={{ borderRightWidth: 0 }}>
                        {inputArr?.find(item => item?.keys === '개중사무소소재지1')?.values}
                        </td>
                        <td colSpan={3} className='alignc' >전화번호</td>
                        <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                        {inputArr?.find(item => item?.keys === '개중전화번호1')?.values}
                        </td>
                    </tr>  

                    {inputArr?.find(item => item?.keys === '공동중개')?.values?.map((x, i) => {
                        let indexNumber = i;         
                        if(i > 0) return;                                       
                        return (
                        <>

                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} rowSpan={3}>개업 공인중개사</td>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >등록번호</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                            {x?.values?.find(item => item?.keys === '공동중개등록번호')?.values}
                            </td>
                            <td colSpan={3} className='alignc' >성명 (대표자)</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>(서명 및 날인)</td>
                        </tr>                                                   
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >사무소 명칭</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                            {x?.values?.find(item => item?.keys === '공동중개사무소명칭')?.values}
                            </td>
                            <td colSpan={3} className='alignc' >소속 공인중개사</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                            {x?.values?.find(item => item?.keys === '공동중개소속공인중개사')?.values}
                            </td>
                        </tr>  
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >사무소 소재지</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                            {x?.values?.find(item => item?.keys === '공동중개사무소소재지')?.values}
                            </td>
                            <td colSpan={3} className='alignc' >전화번호</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                            {x?.values?.find(item => item?.keys === '공동중개전화번호')?.values}
                            </td>
                        </tr>  
                        </>
                        );
                    })}  
                </table>
            </div>

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <th colSpan={30} className='alignc' style={{ borderLeftWidth: 0, borderRightWidth: 0 }} >작성방법(비주거용 건축물)</th>
                    </tr>
                    <tr>
                        <td colSpan={30} style={{ borderLeftWidth: 0, borderRightWidth: 0 }} className='contractmoreText2'>
                            <div>
                                <div className='bolds'>&lt;작성일반&gt;</div>
                                <div>
                                    <p>1.</p>
                                    <p>
                                        "[ ]"있는 항목은 해당하는 "[ ]"안에 √로 표시합니다.
                                    </p>
                                </div>
                                <div>
                                    <p>2.</p>
                                    <p>
                                    세부항목 작성 시 해당 내용을 작성란에 모두 작성할 수 없는 경우에는 별지로 작성하여 첨부하고, 해당란에는 "별지 참고"라고 적습니다.
                                    </p>
                                </div>
                                <div className='bolds margint12'>&lt;세부항목&gt;</div>

                                <div>
                                    <p>1.</p>
                                    <p>「확인ᆞ설명자료」 항목의 “확인ᆞ설명 근거자료 등”에는 개업공인중개사가 확인ᆞ설명 과정에서 제시한 자료를 적으며, “대상물건의 상태에 관한 자료요구 사항”에는 매도(임대)의뢰인에게 요구한 사항 및 그 관련 자료의 제출 여부와 ⑧ 실제 권리관계 또는 공시되지 않은 물건의 권리 사항부터 ⑩ 벽면까지의 항목을 확인하기 위한 자료의 요구 및 그 불응 여부를 적습니다.</p>
                                </div>
                                <div>
                                    <p>2.</p>
                                    <p>① 대상물건의 표시부터 ⑦ 취득 시 부담할 조세의 종류 및 세율까지는 개업공인중개사가 확인한 사항을 적어야 합니다.</p>
                                </div>
                                <div>
                                    <p>3.</p>
                                    <p>① 대상물건의 표시는 토지대장 및 건축물대장 등을 확인하여 적습니다.</p>
                                </div>
                                <div>
                                    <p>4.</p>
                                    <p>② 권리관계의 “등기부 기재사항”은 등기사항증명서를 확인하여 적습니다.</p>
                                </div>
                                <div>
                                    <p>5.</p>
                                    <p>② 권리관계의 “민간임대 등록여부”는 대상물건이 「민간임대주택에 관한 특별법」에 따라 등록된 민간임대주택인지 여부를 같은 법 제60조에 따른 임대주택정보체계에 접속하여 확인하거나 임대인에게 확인하여 “[ ]”안에 √로 표시하고, 민간임대주택인 경우 「민간임 대주택에 관한 특별법」에 따른 권리ᆞ의무사항을 임차인에게 설명해야 합니다.</p>
                                </div>
                                <div style={{ border: '2px solid #000', padding: 3}}>
                                    <p>*</p>
                                    <div>
                                        <p className='fontsize12'>민간임대주택은 「민간임대주택에 관한 특별법」 제5조에 따른 임대사업자가 등록한 주택으로서, 임대인과 임차인간 임대차 계약(재계약 포함)시 다음과 같은 사항이 적용됩니다.</p>
                                        <div className='contractmoreText2' style={{ padding: 0 }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>①</p>
                                                <p className='fontsize12'>같은 법 제44조에 따라 임대의무기간 중 임대료 증액청구는 5퍼센트의 범위에서 주거비 물가지수, 인근 지역의 임대료 변동률
                                                등을 고려하여 같은 법 시행령으로 정하는 증액비율을 초과하여 청구할 수 없으며, 임대차계약 또는 임대료 증액이 있은
                                                후 1년 이내에는 그 임대료를 증액할 수 없습니다.</p>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>②</p>
                                                <p className='fontsize12'>같은 법 제45조에 따라 임대사업자는 임차인이 의무를 위반하거나 임대차를 계속하기 어려운 경우 등에 해당하지 않으
                                                면 임대의무기간 동안 임차인과의 계약을 해제ᆞ해지하거나 재계약을 거절할 수 없습니다.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <p>6.</p>
                                    <p>② 권리관계의 “계약갱신요구권 행사여부”는 대상물건이 「주택임대차보호법」 및 「상가건물 임대차보호법」의 적용을 받는 임차인이 있는 경우 매도인(임대인)으로부터 계약갱신요구권 행사 여부에 관한 사항을 확인할 수 있는 서류를 받으면 “확인”에 √로 표시하여 해 당 서류를 첨부하고, 서류를 받지 못한 경우 “미확인”에 √로 표시합니다. 이 경우 「주택임대차보호법」및 「상가건물 임대차보호법」 에 따른 임대인과 임차인의 권리ᆞ의무사항을 매수인에게 설명해야 합니다.</p>
                                </div>
                                
                                <div>
                                    <p>7.</p>
                                    <p>③ 토지이용계획, 공법상 이용제한 및 거래규제에 관한 사항(토지)의 “건폐율 상한 및 용적률 상한”은 시ᆞ군의 조례에 따라 적고, “도 시ᆞ군계획시설”, “지구단위계획구역, 그 밖의 도시ᆞ군관리계획”은 개업공인중개사가 확인하여 적으며, “그 밖의 이용제한 및 거래규제사항” 은 토지이용계획확인서의 내용을 확인하고, 공부에서 확인할 수 없는 사항은 부동산종합공부시스템 등에서 확인하여 적습니다(임대차의 경우 에는 생략할 수 있습니다).</p>
                                </div>
                                <div>
                                    <p>8.</p>
                                    <p>⑥ 거래예정금액 등의 “거래예정금액”은 중개가 완성되기 전 거래예정금액을, “개별공시지가(m²당)” 및 “건물(주택)공시가격” 은 중개가 완성되기 전 공시된 공시지가 또는 공시가격을 적습니다[임대차의 경우에는 “개별공시지가(m²당)” 및 “건물(주택)공시가 격”을 생략할 수 있습니다].</p>
                                </div>
                                <div>
                                    <p>9.</p>
                                    <p>⑦ 취득 시 부담할 조세의 종류 및 세율은 중개가 완성되기 전 「지방세법」의 내용을 확인하여 적습니다(임대차의 경우에는 제외합 니다).</p>
                                </div>                                
                                <div>
                                    <p>10.</p>
                                    <p>⑧ 취득 시 부담할 조세의 종류 및 세율은 중개가 완성되기 전 「지방세법」의 내용을 확인하여 적습니다(임대차의 경우에는 제외합니다).</p>
                                </div>             
                                <div>
                                    <p>11.</p>
                                    <p>⑨ 실제 권리관계 또는 공시되지 않은 물건의 권리 사항은 매도(임대)의뢰인이 고지한 사항(법정지상권, 유치권, 「상가건물 임대차보호 법」에 따른 임대차, 토지에 부착된 조각물 및 정원수, 계약 전 소유권 변동여부, 도로의 점용허가 여부 및 권리ᆞ의무 승계 대상여부 등) 을 적습니다. 「건축법 시행령」 별표 1 제2호에 따른 공동주택(기숙사는 제외합니다) 중 분양을 목적으로 건축되었으나 분양되지 않아 보존등기만 마쳐진 상태인 공동주택에 대해 임대차계약을 알선하는 경우에는 이를 임차인에게 설명해야 합니다.</p>
                                </div>
                                <div >
                                    <p></p>
                                    <div>
                                        <div className='contractmoreText2' style={{ padding: 0, paddingLeft: 10  }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>※</p>
                                                <p className='fontsize12'>임대차계약의 경우 임대보증금, 월 단위의 차임액, 계약기간, 장기수선충당금의 처리 등을 확인하고, 근저당 등이 설정된 경우 채권최고액을 확인하 여 적습니다. 그 밖에 경매 및 공매 등의 특이사항이 있는 경우 이를 확인하여 적습니다.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>       
                                <div>
                                    <p>12.</p>
                                    <p>⑨ 내부ᆞ외부 시설물의 상태(건축물) 및 ⑩ 벽면 및 바닥면은 중개대상물에 대하여 개업공인중개사가 매도(임대)의뢰인에게 자료를 요구하여 확인한 사항을 적고, 9 내부ᆞ외부 시설물의 상태(건축물)의 "그 밖의 시설물"에는 건축물이 상업용인 경우에는 오수정 화시설용량, 공업용인 경우에는 전기용량, 오수정화시설용량 및 용수시설의 내용에 대하여 개업공인중개사가 매도(임대)의뢰인에 게 자료를 요구하여 확인한 사항을 적습니다.</p>
                                </div>
                                <div>
                                    <p>13.</p>
                                    <p>⑪ 중개보수 및 실비의 금액과 산출내역은 개업공인중개사와 중개의뢰인이 협의하여 결정한 금액을 적되 “중개보수”는 거래예정금액을 기 준으로 계산하고, “산출내역(중개보수)”은 “거래예정금액(임대차의 경우에는 임대보증금 + 월 단위의 차임액 × 100) × 중개보수 요율”과 같이 적습니다. 다만, 임대차로서 거래예정금액이 5천만원 미만인 경우에는 “임대보증금 + 월 단위의 차임액 × 70”을 거래예정금액으로 합니다.</p>
                                </div>
                                <div>
                                    <p>14.</p>
                                    <p>공동중개 시 참여한 개업공인중개사(소속공인중개사를 포함합니다)는 모두 서명ᆞ날인해야 하며, 2명을 넘는 경우에는 별지로 작성하여 첨부합니다.</p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>  

            
            <div style={{ width: '100%', height: 1040, }}></div>
            <div>
            {pageArr?.map((x, i) => {
                let subheight = 279;
                let subheightplus = 279;
                                
                return (
                <>
                    <div style={{ height: 1118,  }}>
                        <div 
                            className='fontsize12' 
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 8, marginBottom: 10
                            }}
                        >
                            <div style={{ fontSize: 20, fontWeight: 700}}>
                                확인설명서 별지 
                            </div>
                        </div>                
                        <div 
                            className='fontsize12' style={{ width: '100%', marginBottom: 10 }}
                        >
                            <table className='contractTable lrbordernone'>
                                <tr>
                                    <td colSpan={30} style={{ borderLeftWidth: 0, borderRightWidth: 0, height: 30 }} className='bolds'>I. 개업공인중개사 기본 확인사항</td>
                                </tr>
                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={9}>① 대상물건의 표시</td>
                                    <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>토지</td>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }}>소재지</td>
                                    <td colSpan={22} style={{ borderRightWidth: 0 }}>
                                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-소재지')?.values}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>면적(m²)</td>
                                    <td colSpan={8} rowSpan={2}>
                                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-면적')?.values}                         
                                    </td>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>지목</td>
                                    <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }}>공부상 지목</td>
                                    <td colSpan={7} style={{ borderRightWidth: 0 }}>
                                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-지목-공부상지목')?.values}                        
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }}>실제 이용 상태</td>
                                    <td colSpan={7} style={{ borderRightWidth: 0 }}>
                                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-지목-실제이용상태')?.values}                     
                                    </td>
                                </tr>

                                <tr>
                                    <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={6}>건축물</td>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }}>전용면적(m²)</td>
                                    <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-전용면적')?.values}                        
                                    </td>
                                    <td colSpan={4} className='alignc' >대지지분(m²)</td>
                                    <td colSpan={7} style={{ borderRightWidth: 0 }}>
                                        {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-대지지분')?.values}                      
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>준공년도<br />(증개축년도)</td>
                                    <td colSpan={8} rowSpan={2}>
                                    {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-준공년도')?.values}                          
                                    </td>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>용도</td>
                                    <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }}>건축물대장상 용도</td>
                                    <td colSpan={7} style={{ borderRightWidth: 0 }}>
                                    {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-건축물대장상용도')?.values}                         
                                    </td>
                                </tr>          
                                <tr>
                                    <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }}>실제 용도</td>
                                    <td colSpan={7} style={{ borderRightWidth: 0 }}>
                                    {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-실제용도')?.values}                           
                                    </td>
                                </tr>    
                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }}>구조</td>
                                    <td colSpan={8} style={{ borderRightWidth: 0 }}>
                                    {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-구조')?.values}                            
                                    </td>
                                    <td colSpan={5} className='alignc' >방향</td>
                                    <td colSpan={9} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                        <div className='displayflexstart' style={{ gap: 4 }}>
                                            <div>
                                            {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-방향')?.values}                             
                                            </div>
                                            <div className='' style={{ gap: 4 }}>
                                                <span style={{ width: 40 }}>(기준 : {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-기준')?.values})</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>   
                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, fontSize: 11, letterSpacing: -1 }}>내진설계 적용여부</td>
                                    <td colSpan={8} style={{ borderRightWidth: 0 }}>
                                    {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-내진설계적용여부')?.values}
                                    </td>
                                    <td colSpan={7} className='alignc' >내진능력</td>
                                    <td colSpan={7} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                    {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-내진능력')?.values}
                                    </td>
                                </tr>                      
                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, fontSize: 12, letterSpacing: -1 }}>건축물대장상<br />위반건축물 여부</td>
                                    <td colSpan={8} style={{ borderRightWidth: 0 }}>
                                    {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-위반건축물여부')?.values}                              
                                    </td>
                                    <td colSpan={3} className='alignc' >위반내용</td>
                                    <td colSpan={11} style={{ borderRightWidth: 0, }}>
                                    {inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-위반내용')?.values}
                                    </td>
                                </tr>                     
                            </table>
                        </div>   
                        {(inputArr?.find(item => item?.keys === '특약사항')?.values?.length - commentcount) > 0 && subheightplus < 1116 &&
                        <>

                        <div 
                            className='fontsize12' style={{ width: '100%', }}
                        >
                            <table className='contractTable'>
                                {inputArr?.find(item => item?.keys === '특약사항')?.values?.map((x, i) => {
                                    if(i < 1) return;
                                    if(commentcount >= inputArr?.find(item => item?.keys === '특약사항')?.values?.length){
                                        return;
                                    }
                                    if(i < commentcount){
                                        return;
                                    }
                                    let countHeight = 305.5 + (subheight);
                                    if(countHeight > 1116){
                                        subheightplus = countHeight;
                                        return;
                                    }
                                    subheight = countHeight;
                                    commentcount = commentcount+1;
                                    return (
                                        <tr>
                                            <td colSpan={30} style={{ padding: 0, verticalAlign: 'top', overflow: 'hidden' }}>
                                                <p style={{ padding: '10px 10px 0px', fontSize: 12  }}>특약사항</p>
                                                <div style={{ padding: 10, whiteSpace: 'pre-wrap', height: 280 }}>
                                                    {x?.values}
                                                </div>
                                            </td>
                                        </tr>     
                                    );
                                })}
                            </table>
                        </div>
                        </>
                        }
                        {(inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가')?.values?.length - commentcount) > 0 && subheightplus < 1116 &&
                        <>
                        {inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가')?.values?.map((x, i) => {
                            if(commentcount >= inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가')?.values?.length){
                                return;
                            }
                            if(i < commentcount){
                                return;
                            }
                            let countHeight = 598 + (subheight);
                            if(countHeight > 1116){
                                subheightplus = countHeight;
                                return;
                            }
                            subheight = countHeight;
                            commentcount = commentcount+1;                            
                            return (
                                <div 
                                    className='fontsize12' style={{ width: '100%' }}
                                >
                                    <table className='contractTable lrbordernone'>
                                        <tr>
                                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>
                                                ② 권리관계
                                            </td>
                                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>등기부 기재사항</td>
                                            <td colSpan={12} className='alignc' style={{ borderLeftWidth: 0 }}>소유권에 관한 사항</td>
                                            <td colSpan={12} className='alignc' style={{ borderRightWidth: 0 }}>소유권 외의 권리사항</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >토지</td>
                                            <td colSpan={9} style={{ borderRightWidth: 0, whiteSpace: 'pre-wrap' }}>
                                            {x?.values?.find(item => item?.keys === '토지1')?.values}
                                            </td>


                                            <td colSpan={3} className='alignc' >토지</td>
                                            <td colSpan={9} style={{ borderRightWidth: 0, whiteSpace: 'pre-wrap' }}>
                                            {x?.values?.find(item => item?.keys === '토지2')?.values}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >건축물</td>
                                            <td colSpan={9} style={{ borderRightWidth: 0, whiteSpace: 'pre-wrap' }}>
                                            {x?.values?.find(item => item?.keys === '건축물1')?.values}                                                
                                            </td>
                                            <td colSpan={3} className='alignc' >건축물</td>
                                            <td colSpan={9} style={{ borderRightWidth: 0, whiteSpace: 'pre-wrap' }}>
                                            {x?.values?.find(item => item?.keys === '건축물2')?.values}                        
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            );
                        })}
                        </>}
                        {(inputArr?.find(item => item?.keys === '매도인')?.values?.length - buyercount) > 0 && subheightplus < 1116 &&
                        <>
                        <div 
                            className='fontsize12' style={{ width: '100%' }}
                        >
                            <table className='contractTable lrbordernone'>
                            {inputArr?.find(item => item?.keys === '매도인')?.values?.map((x, i) => {
                                if(i < 1) return;
                                if(buyercount >= inputArr?.find(item => item?.keys === '매도인')?.values?.length){
                                    return;
                                }
                                if(i < buyercount){
                                    return;
                                }
                                let countHeight = 70 + (subheight);
                                if(countHeight > 1116){
                                    subheightplus = countHeight;
                                    return;
                                }
                                subheight = countHeight;
                                buyercount = buyercount+1;     
                                return (
                                <>

                            
                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>매도인 (임대인)</td>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >주소</td>
                                    <td colSpan={11} style={{ borderRightWidth: 0, height: 35 }}>
                                        {x?.values?.find(item => item?.keys === '매도인주소')?.values}
                                        {x?.subflag &&
                                            <><br />{x?.values?.find(item => item?.keys === '대리인주소')?.values}</>
                                        }
                                    </td>
                                    <td colSpan={3} className='alignc' >성명</td>
                                    <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right', height: 35 }}>
                                        (서명 또는 날인)
                                        {x?.subflag &&
                                        <><br />(서명 또는 날인)</>
                                        }                                
                                    </td>
                                </tr>                                                   
                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >생년월일</td>
                                    <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                        {x?.values?.find(item => item?.keys === '매도인주민번호')?.values}
                                        {x?.subflag &&
                                            <><br />{x?.values?.find(item => item?.keys === '대리인주민번호')?.values}</>
                                        }
                                    </td>
                                    <td colSpan={3} className='alignc' >전화번호</td>
                                    <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right', height: 35 }}>
                                        {x?.values?.find(item => item?.keys === '매도인전화')?.values}
                                        {x?.subflag &&
                                            <><br />{x?.values?.find(item => item?.keys === '대리인전화')?.values}</>
                                        }
                                    </td>
                                </tr>        
                                </>
                                );
                            })}     
                            </table>
                        </div> 
                        </>}

                        {(inputArr?.find(item => item?.keys === '매수인')?.values?.length - sellercount) > 0 && subheightplus < 1116 &&
                        <>
                        <div 
                            className='fontsize12' style={{ width: '100%' }}
                        >
                            <table className='contractTable lrbordernone'>
                            {inputArr?.find(item => item?.keys === '매수인')?.values?.map((x, i) => {
                                if(i < 1) return;
                                if(sellercount >= inputArr?.find(item => item?.keys === '매수인')?.values?.length){
                                    return;
                                }
                                if(i < sellercount){
                                    return;
                                }
                                let countHeight = 70 + (subheight);
                                if(countHeight > 1116){
                                    subheightplus = countHeight;
                                    return;
                                }
                                subheight = countHeight;
                                sellercount = sellercount+1;     
                                return (
                                <>

                            
                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} rowSpan={2}>매수인 (임차인)</td>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >주소</td>
                                    <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                        {x?.values?.find(item => item?.keys === '매수인주소')?.values}
                                        {x?.subflag &&
                                            <><br />{x?.values?.find(item => item?.keys === '대리인주소')?.values}</>
                                        }
                                    </td>
                                    <td colSpan={3} className='alignc' >성명</td>
                                    <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                        (서명 또는 날인)
                                        {x?.subflag &&
                                        <><br />(서명 또는 날인)</>
                                        }                                
                                    </td>
                                </tr>                                                   
                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >생년월일</td>
                                    <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                        {x?.values?.find(item => item?.keys === '매수인주민번호')?.values}
                                        {x?.subflag &&
                                            <><br />{x?.values?.find(item => item?.keys === '대리인주민번호')?.values}</>
                                        }
                                    </td>
                                    <td colSpan={3} className='alignc' >전화번호</td>
                                    <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                        {x?.values?.find(item => item?.keys === '매수인전화')?.values}
                                        {x?.subflag &&
                                            <><br />{x?.values?.find(item => item?.keys === '대리인전화')?.values}</>
                                        }
                                    </td>
                                </tr>        
                                </>
                                );
                            })}
                            </table>
                        </div> 
                        </>}
                        {(inputArr?.find(item => item?.keys === '공동중개')?.values?.length - togethercount) > 0 && subheightplus < 1116 &&
                        <>
                        <div 
                            className='fontsize12' style={{ width: '100%' }}
                        >
                            <table className='contractTable lrbordernone'>
                            {inputArr?.find(item => item?.keys === '공동중개')?.values?.map((x, i) => {
                                if(togethercount >= inputArr?.find(item => item?.keys === '공동중개')?.values?.length){
                                    return;
                                }
                                if(i < togethercount){
                                    return;
                                }
                                let countHeight = 105 + (subheight);
                                if(countHeight > 1116){
                                    subheightplus = countHeight;
                                    return;
                                }
                                subheight = countHeight;
                                togethercount = togethercount+1;                                  
                                return (
                                <>

                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} rowSpan={3}>개업 공인중개사</td>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >등록번호</td>
                                    <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                    {x?.values?.find(item => item?.keys === '공동중개등록번호')?.values}
                                    </td>
                                    <td colSpan={3} className='alignc' >성명 (대표자)</td>
                                    <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>(서명 및 날인)</td>
                                </tr>                                                   
                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >사무소 명칭</td>
                                    <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                    {x?.values?.find(item => item?.keys === '공동중개사무소명칭')?.values}
                                    </td>
                                    <td colSpan={3} className='alignc' >소속 공인중개사</td>
                                    <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                    {x?.values?.find(item => item?.keys === '공동중개소속공인중개사')?.values}
                                    </td>
                                </tr>  
                                <tr>
                                    <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, height: 35 }} >사무소 소재지</td>
                                    <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                    {x?.values?.find(item => item?.keys === '공동중개사무소소재지')?.values}
                                    </td>
                                    <td colSpan={3} className='alignc' >전화번호</td>
                                    <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                    {x?.values?.find(item => item?.keys === '공동중개전화번호')?.values}
                                    </td>
                                </tr>  
                                </>
                                );
                            })}  
                            </table>
                        </div> 
                        </>}
                    </div>                 
                </>
                );
            })}
            </div>
        </div>
    )    
}